import { element, useElementProps } from '../../../core/elements';
import Group from '../../../primitives/shape/Group';
import { BarGroup } from '../../bar/elements/bar-group';
import { BarGroupHorizontalLabels } from './bar-group-horizontal-label';
import { BarGroupHorizontalMarks } from './bar-group-horizontal-marks';
import { getHorizontalBarGroups } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BarGroupHorizontal(props) {
  const {
    data,
    top,
    left,
    xScale,
    yScale,
    colorScale,
    groupScale,
    colorAccessor,
    groupAccessor,
    valueAccessor,
    xAccessor
  } = useElementProps(BarGroup, {
    mergeWith: props
  });
  const barGroups = getHorizontalBarGroups(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor);
  return /*#__PURE__*/_jsxs(Group, {
    top: top,
    left: left,
    children: [/*#__PURE__*/_jsx(BarGroupHorizontalMarks, {
      barGroups: barGroups,
      roundedCorners: true
    }), /*#__PURE__*/_jsx(BarGroupHorizontalLabels, {
      barGroups: barGroups,
      hide: true
    })]
  });
}
const _BarGroupHorizontal = element(BarGroupHorizontal, {
  as: BarGroup
});
export { _BarGroupHorizontal as BarGroupHorizontal };